import { phpRequest } from "./phpRequest";

export const uploadExistingDevicesAPI = (excelFile) => {
  let formData = new FormData();
  formData.append("spreadsheet", excelFile);
  return phpRequest.post("/devices/do-action-by-excel", formData);
};
